import { render, staticRenderFns } from "./ProjectSolvers.vue?vue&type=template&id=f9fa2eee"
import script from "./ProjectSolvers.vue?vue&type=script&lang=ts"
export * from "./ProjectSolvers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports